import regImage from "./Images/registerImg.webp";

function RegisterPage(){
    return(
        <>
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col">
                        <div className="card my-4 contactCardColor border border-1 border-dark">
                            <div className="row g-0">
                                <div className="col-xl-6">
                                    <img src={regImage} alt="" className="img-fluid h-100" />
                                </div>
                                <div className="col-xl-6">
                                    <div className="card-body p-md-5 text-black text-sm-danger">
                                        <h3 className="mb-5 text-uppercase fw-bold headingCls">
                                            Student registration form
                                        </h3>
                                        <form>
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div>
                                                        <input type="text" id="firstName" className="form-control text-muted form-control-lg" />
                                                        <label className="form-label fw-bold" htmlFor="firstName">First name</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-4">
                                                    <div>
                                                        <input type="text" id="lastName" className="form-control text-muted form-control-lg"/>
                                                        <label className="form-label fw-bold" htmlFor="lastName">Last name</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div>
                                                        <input type="text" id="motherName" className="form-control text-muted form-control-lg"/>
                                                        <label className="form-label fw-bold" htmlFor="motherName">Mother's name</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-4">
                                                    <div>
                                                        <input type="text" id="fatherName" className="form-control text-muted form-control-lg"/>
                                                        <label className="form-label fw-bold" htmlFor="fatherName">Father's name</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-4">
                                                <input type="text" id="address" className="form-control text-muted form-control-lg"/>
                                                <label className="form-label fw-bold" htmlFor="address">Address</label>
                                            </div>
                                            <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                <h6 className="mb-0 me-4 fw-bold">Gender:</h6>
                                                <div className="form-check form-check-inline mb-0 me-4">
                                                    <input className="form-check-input" type="radio" name="gender" id="femaleGender" value="option1"/>
                                                    <label className="form-check-label" htmlFor="femaleGender">Female</label>
                                                </div>
                                                <div className="form-check form-check-inline mb-0 me-4">
                                                    <input className="form-check-input" type="radio" name="gender" id="maleGender" value="option2"/>
                                                    <label className="form-check-label" htmlFor="maleGender">Male</label>
                                                </div>
                                                <div className="form-check form-check-inline mb-0">
                                                    <input className="form-check-input" type="radio" name="gender" id="otherGender" value="option3"/>
                                                    <label className="form-check-label" htmlFor="otherGender">Other</label>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <select className="select">
                                                        <option value="1">State&nbsp;&nbsp;&nbsp;</option>
                                                        <option value="2">AP</option>
                                                        <option value="3">TS</option>
                                                        <option value="4">KA</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-6 mb-4">
                                                    <select className="select">
                                                        <option value="1">City</option>
                                                        <option value="2">Hyderabad</option>
                                                        <option value="3">Bangalore</option>
                                                        <option value="4">Chennai</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="mb-4">
                                                <input type="date" id="dob" className="form-control text-muted form-control-lg mb-1"/>
                                                <label className="form-label fw-bold" htmlFor="dob">Date of Birth</label>
                                            </div>
                                            <div className="mb-4">
                                                <input type="text" id="pincode" className="form-control text-muted form-control-lg"/>
                                                <label className="form-label fw-bold" htmlFor="pincode">Pincode</label>
                                            </div>
                                            <div className="mb-4">
                                                <input type="text" id="course" className="form-control text-muted form-control-lg"/>
                                                <label className="form-label fw-bold" htmlFor="course">Course</label>
                                            </div>
                                            <div className="mb-4">
                                                <input type="email" id="email" className="form-control text-muted form-control-lg" />
                                                <label className="form-label fw-bold" htmlFor="email">Email ID</label>
                                            </div>
                                            <div className="d-flex justify-content-end pt-3">
                                                <button type="reset" className="btn btn-light btn-lg headingCls">Reset all</button>
                                                <button type="button" className="btn btn-warning btn-lg ms-2 headingCls">Submit form</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}export default RegisterPage